import { render, staticRenderFns } from "./StudentVirtualList.vue?vue&type=template&id=7f63fda9&scoped=true&"
import script from "./StudentVirtualList.vue?vue&type=script&lang=js&"
export * from "./StudentVirtualList.vue?vue&type=script&lang=js&"
import style0 from "./StudentVirtualList.vue?vue&type=style&index=0&id=7f63fda9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f63fda9",
  null
  
)

export default component.exports